import privacyPdf from '../../documents/20220707-privacy-policy.pdf';

const Privacy = () => {
    window.location.href = privacyPdf;
};

export default Privacy;
